import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useCalendars = () => {
  const { household } = useAuth()

  return useQuery({
    queryKey: ['calendars', household?.id],
    queryFn: async () => {
      if (!household?.id) return []
      const { data, error } = await supabase
        .from('calendars')
        .select('id, name, color, created_by')
        .eq('household_id', household.id)
        .order('name')
      if (error) throw error
      return data ?? []
    },
    enabled: !!household?.id,
  })
}

export const useCreateCalendar = () => {
  const { household, user } = useAuth()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({ name, color }) => {
      const { data, error } = await supabase
        .from('calendars')
        .insert({ name, color, household_id: household.id, created_by: user.id })
        .select()
        .single()
      if (error) throw error
      return data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['calendars', household?.id] }),
  })
}

export const useUpdateCalendar = () => {
  const { household } = useAuth()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, name, color }) => {
      const { error } = await supabase.from('calendars').update({ name, color }).eq('id', id)
      if (error) throw error
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['calendars', household?.id] }),
  })
}

export const useDeleteCalendar = () => {
  const { household } = useAuth()
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase.from('calendars').delete().eq('id', id)
      if (error) throw error
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['calendars', household?.id] })
      qc.invalidateQueries({ queryKey: ['events', household?.id] })
    },
  })
}
